// Centralized API + analytics helpers used across the app.
// Imports stay minimal so any page can pull just what it needs.

import axios from "axios";

// In production we mount frontend and backend on the same origin behind a proxy.
// In preview the same logic holds. Always use window.location.origin.
const getApiBaseUrl = () => window.location.origin;

export const BACKEND_URL = getApiBaseUrl();
export const API = `${BACKEND_URL}/api`;

// Anonymous visitor id (persists across sessions in localStorage)
export const getVisitorId = () => {
  let id = localStorage.getItem("union_visitor_id");
  if (!id) {
    id = `v_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem("union_visitor_id", id);
  }
  return id;
};

export const getDeviceType = () => {
  const w = window.innerWidth;
  if (w < 768) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
};

export const trackPageView = (page) => {
  try {
    axios
      .post(`${API}/analytics/pageview`, {
        visitor_id: getVisitorId(),
        page,
        referrer: document.referrer || null,
        device: getDeviceType(),
      })
      .catch(() => {});
  } catch (e) {
    /* no-op */
  }
};

export const trackUnionClick = (unionId, unionName) => {
  try {
    axios
      .post(`${API}/analytics/union-click`, {
        visitor_id: getVisitorId(),
        union_id: unionId,
        union_name: unionName,
      })
      .catch(() => {});
  } catch (e) {
    /* no-op */
  }
};

// Route external CDN images through the same-origin backend proxy
export const proxied = (url) => {
  if (!url) return url;
  try {
    const u = new URL(url);
    if (u.host.includes("customer-assets.emergent")) {
      return `${BACKEND_URL}/api/img?url=${encodeURIComponent(url)}`;
    }
  } catch (e) {
    /* no-op */
  }
  return url;
};
